import { render, staticRenderFns } from "./TrainFile.vue?vue&type=template&id=b583972a&scoped=true"
import script from "./TrainFile.vue?vue&type=script&lang=js"
export * from "./TrainFile.vue?vue&type=script&lang=js"
import style0 from "./TrainFile.vue?vue&type=style&index=0&id=b583972a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b583972a",
  null
  
)

export default component.exports